<template>
  
<Topbar />
<div class="d-flex slim-top app-shell">
  <Sidebar />
  <div class="flex-grow-1 w-100 bg-sa-main-content d-flex flex-column">
    <Breadcrumb />
    <!--Page-content Div: grows to fill the space, so the footer sits at the bottom on short pages-->
    <div class="p-2 flex-grow-1">      
      <AutoLogout />
      <router-view />
      <!--<router-view  :key="$route.fullPath"/>-->
    </div>
    <!--End Page-content Div-->
    <Footer />
  </div>
</div>

</template>

<script>
import { nextTick } from 'vue'
import { initAdminScripts } from '@/utils/adminScripts'

import { onMounted } from 'vue'
import { loadScript, loadStyle } from '@/utils/scriptLoader'

import Topbar from '@/components/admin/Topbar.vue'
import Breadcrumb from '@/components/admin/Breadcrumb.vue'
import Sidebar from '@/components/admin/Sidebar.vue'
import Footer from '@/components/admin/Footer.vue'
import AutoLogout from '@/components/ui/AutoLogout.vue';

export default {
  components: {
    AutoLogout,
    Topbar,
    Breadcrumb,
    Sidebar,
    Footer
  },
async mounted() {
  /*loadStyle('https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/css/bootstrap.min.css')
  loadStyle('https://cdn.jsdelivr.net/npm/select2@4.1.0-rc.0/dist/css/select2.min.css')
  loadStyle('https://code.jquery.com/ui/1.13.2/themes/base/jquery-ui.css')
  loadStyle('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css')
  loadStyle('https://cdnjs.cloudflare.com/ajax/libs/animate.css/4.1.1/animate.min.css')
  loadStyle('https://cdn.jsdelivr.net/npm/select2-bootstrap-5-theme@1.3.0/dist/select2-bootstrap-5-theme.min.css')
  loadStyle('/assets/admin/custom.css')*/

  /*await loadStyle('https://code.jquery.com/ui/1.13.2/themes/base/jquery-ui.css')
  await loadScript('https://code.jquery.com/jquery-3.6.0.min.js')
  await loadScript('https://code.jquery.com/ui/1.13.2/jquery-ui.min.js')
  await loadScript('https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/js/bootstrap.bundle.min.js')
  await loadScript('https://cdn.jsdelivr.net/npm/select2@4.1.0-rc.0/dist/js/select2.min.js')
  await loadScript('https://cdn.jsdelivr.net/npm/chart.js@4.5.1/dist/chart.umd.min.js')
  await loadScript('/js/admin/custom.js')
  await loadScript('/js/formValidations.js')*/
  await nextTick()
  initAdminScripts(true)
}
}
</script>
